import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import Step1 from "../../../components/qualify_questions_steps/Step1";
import Step2 from "../../../components/qualify_questions_steps/Step2";
import Step3 from "../../../components/qualify_questions_steps/Step3";
import Step4 from "../../../components/qualify_questions_steps/Step4";
import EditPhotos from "../../../components/qualify_questions_steps/EditPhotos";
import Step6 from "../../../components/qualify_questions_steps/Step6";
import * as actions from "../../../store/actions";

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '24px',
        marginBlockEnd: '8px'
    },
    instructions: {
        fontFamily: "Mulish",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "20px",
        lineHeight: "25px",
        color: "#FEFFFF"
    }
}));

function getStepContent(step, vehicleUpdated) {
    switch (step) {
        case 1:
            return (<Step1 backButton="Cancel" nextButton="Next"/>)
        case 2:
            return (<Step2 backButton="Back" nextButton="Next"/>)
        case 3:
            return (<Step3/>)
        case 4:
            return (<Step4/>)      
        case 5:
            return (<EditPhotos backButton="Back" nextButton="Save"/>)
        case 6:
            return (<Step6 vehicleUpdated={vehicleUpdated} noMatchingClients={!vehicleUpdated} />)
        default:
            return (<Step1 backButton="Cancel" nextButton="Next"/>)
    }
}

const EditVehicle = (props) => {

    const classes = useStyles();

    let title

    React.useEffect(() => {
        return () => {
            props.resetErrors();
        }
    }, [props.qualifyVehicle.step])

    switch (props.qualifyVehicle.step) {
        case 5:
            title = 'Add Photos'
            break
        case 6:
            if (props.vehicleAdded) {
                title = 'Vehicle Updated!'
            } else {
                title = 'No Matches Found'
            }
            break
        default:
            title = 'Edit Vehicle'
    }

    return (
        <React.Fragment>
            <h1 className={classes.title}>{title}</h1>
            {getStepContent(props.qualifyVehicle.step, props.vehicleAdded)}
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        qualifyVehicle: state.qualifyVehicle,
        vehicleAdded: state.qualifyVehicle && state.qualifyVehicle.matchingClients && state.qualifyVehicle.matchingClients.length,
        selectedVehicle: state.app.selectedVehicle
    };
};

const mapDispatchToProps = dispatch => {
    return {
        resetErrors: () => dispatch(actions.qualifyVehicleResetErrors())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditVehicle);